<template>
  <v-banner
    :value="showUpdateBanner"
    button
    :elevation="6"
    style="z-index:1"
  >
    Vjago has been updated, please reload the app.
    If you continue to see this message, close and re-open the app.
    <template v-slot:actions>
      <v-btn
        text
        color="accent"
        @click="dismiss"
      >
        Later
      </v-btn>

      <v-btn
        text
        color="accent"
        @click="reload"
      >
        Reload
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([ 'showUpdateBanner' ])
  },
  methods: {
    dismiss () {
      this.$store.commit('showUpdateBanner', false)
    },
    reload () {
      window.location.reload(true)
    }
  }
}
</script>

<style>

</style>
